import { API } from "aws-amplify";
import Auth from "@aws-amplify/auth";
import { store } from "../../store";

const getHeaders = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = user.signInUserSession?.accessToken?.jwtToken;
  const headers = {};
  if (jwtToken) headers['Authorization'] = 'Bearer ' + jwtToken;
  const { loginReducer } = store.getState();
  const clientId = loginReducer?.groups?.[0];
  if (clientId) headers['BluStream-Client-ID'] = clientId;
  return headers;
};

const customerUuid = () => {
  const { loginReducer } = store.getState();
  return loginReducer?.groups?.[0];
};

export const getCatalogItems = async (page = 0, size = 20, search = "") => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  let path = `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/catalog-items?page=${page}&size=${size}`;
  if (search) path += `&search=${encodeURIComponent(search)}`;
  return API.get("blustreamREST", path, { headers });
};

export const getCatalogItem = async (itemId) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/integrations/klaviyo/customer/${uuid}/catalog-items/${itemId}`, { headers });
};

export const triggerCatalogSync = async (customerId) => {
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/admin/klaviyo/catalog-sync-job`, { headers, body: { customerId } });
};

export const getSyncJobs = async (customerId) => {
  const cid = customerId || customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/klaviyo/catalog-sync-job?customerId=${cid}`, { headers });
};

export const getRunningSyncJobs = async (customerId) => {
  const cid = customerId || customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/klaviyo/catalog-sync-job/running?customerId=${cid}`, { headers });
};

export const getSyncJob = async (jobId, customerId) => {
  const cid = customerId || customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/admin/klaviyo/catalog-sync-job/${jobId}?customerId=${cid}`, { headers });
};
